export const blog = [
  'company_registry_guides',
  'kyb_compliance',
  'ownership_corporate_structure',
  'financials_credit_risk',
  'company_data_ai',
  'tax_regulatory_insights',
  'platforms_comparisons',
  'global_database_updates',
  'top_gdb_companies',
];

export const caseStudiesCategories = ['category_1', 'category_2', 'category_3'];

export const customersTypesWithUnderscore = {
  category_1: 'sales-and-marketing',
  category_2: 'compliance',
  category_3: 'data-enrichment',
} as { [key: string]: string };

export const exceptionSitemapPages = ['customers', 'blog', 'author'];

export const careerTypes = ['engineering', 'sales', 'customer_success', 'marketing', 'operational'];
